function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled, { css } from "styled-components";
import { warning } from "@kiwicom/js";
import defaultTheme from "../defaultTheme";
import { ICON_SIZES } from "../Icon/consts";
import { TYPE_OPTIONS, SIZE_OPTIONS, TOKENS, BUTTON_STATES } from "./consts";
import Loading, { StyledSpinner } from "../Loading";
import { getSize } from "../Icon";
import getSpacingToken from "../common/getSpacingToken";
import getSizeToken from "./helpers/getSizeToken";
import getTypeToken from "./helpers/getTypeToken";
import getButtonSpacing from "./helpers/getButtonSpacing";
import getIconSpacing from "./helpers/getIconSpacing";
import getButtonBoxShadow from "./helpers/getButtonBoxShadow";
import getFocus from "./helpers/getFocus"; // media query only for IE 10+, not Edge

var onlyIE = function onlyIE(style) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";
  return css(["@media ", " and (-ms-high-contrast:none),(-ms-high-contrast:active){", ";}"], breakpoint, style);
};

var IconContainer = styled(function (_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "Button__IconContainer",
  componentId: "sc-1brqp3f-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;margin:", ";color:", ";transition:background ", " ease-in-out,box-shadow ", " ease-in-out;> svg{width:", ";height:", ";}"], getIconSpacing(), function (_ref4) {
  var bordered = _ref4.bordered;
  return bordered ? getTypeToken(TOKENS.colorTextButtonBordered) : getTypeToken(TOKENS.colorTextButton);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.durationFast;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.durationFast;
}, function (_ref7) {
  var sizeIcon = _ref7.sizeIcon;
  return getSize(sizeIcon);
}, function (_ref8) {
  var sizeIcon = _ref8.sizeIcon;
  return getSize(sizeIcon);
});
IconContainer.defaultProps = {
  theme: defaultTheme
};
export var StyledButton = styled(function (_ref) {
  var theme = _ref.theme,
      component = _ref.component,
      circled = _ref.circled,
      external = _ref.external,
      type = _ref.type,
      icon = _ref.icon,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      sizeIcon = _ref.sizeIcon,
      width = _ref.width,
      bordered = _ref.bordered,
      loading = _ref.loading,
      onlyIcon = _ref.onlyIcon,
      fullWidth = _ref.fullWidth,
      style = _ref.style,
      dataTest = _ref.dataTest,
      submit = _ref.submit,
      buttonRef = _ref.buttonRef,
      ariaControls = _ref.ariaControls,
      ariaExpanded = _ref.ariaExpanded,
      spaceAfter = _ref.spaceAfter,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["theme", "component", "circled", "external", "type", "icon", "iconLeft", "iconRight", "sizeIcon", "width", "bordered", "loading", "onlyIcon", "fullWidth", "style", "dataTest", "submit", "buttonRef", "ariaControls", "ariaExpanded", "spaceAfter", "title"]);

  var isButtonWithHref = component === "button" && props.href;
  var Component = isButtonWithHref ? "a" : component;
  var buttonType = submit ? "submit" : "button";
  return React.createElement(Component, _extends({
    "data-test": dataTest,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    "aria-label": title,
    type: !isButtonWithHref ? buttonType : undefined
  }, props, {
    ref: buttonRef
  }), props.children);
}).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1brqp3f-1"
})(["position:relative;display:", ";justify-content:center;align-items:center;box-sizing:border-box;appearance:none;text-decoration:none;width:", ";flex:", ";max-width:100%;height:", ";background:", ";color:", " !important;border:0;border-radius:", ";padding:", ";font-family:", ";font-weight:", "!important;font-size:", ";cursor:", ";transition:all 0.15s ease-in-out !important;outline:0;opacity:", ";margin-bottom:", ";", ";&:hover{background:", ";color:", "!important;", ";", "{color:", ";}}&:active{", ";}", " ", "{width:", ";height:", ";}"], function (_ref9) {
  var href = _ref9.href,
      component = _ref9.component;
  return href || component === "a" ? "inline-flex" : "flex";
}, function (_ref10) {
  var fullWidth = _ref10.fullWidth,
      width = _ref10.width,
      onlyIcon = _ref10.onlyIcon;
  return fullWidth ? "100%" : width && "".concat(width, "px") || onlyIcon && getSizeToken(TOKENS.heightButton) || "auto";
}, function (_ref11) {
  var fullWidth = _ref11.fullWidth;
  return fullWidth ? "1 1 auto" : "0 0 auto";
}, getSizeToken(TOKENS.heightButton), function (_ref12) {
  var bordered = _ref12.bordered;
  return bordered ? getTypeToken(TOKENS.backgroundButtonBordered) : getTypeToken(TOKENS.backgroundButton);
}, function (_ref13) {
  var bordered = _ref13.bordered;
  return bordered ? getTypeToken(TOKENS.colorTextButtonBordered) : getTypeToken(TOKENS.colorTextButton);
}, function (_ref14) {
  var theme = _ref14.theme,
      circled = _ref14.circled;
  return circled ? getSizeToken(TOKENS.heightButton) : theme.orbit.borderRadiusNormal;
}, getButtonSpacing(), function (_ref15) {
  var theme = _ref15.theme;
  return theme.orbit.fontFamily;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.orbit.fontWeightBold;
}, getSizeToken(TOKENS.fontSizeButton), function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled ? "not-allowed" : "pointer";
}, function (_ref18) {
  var disabled = _ref18.disabled,
      theme = _ref18.theme;
  return disabled && theme.orbit.opacityButtonDisabled;
}, getSpacingToken, getButtonBoxShadow(BUTTON_STATES.DEFAULT), function (_ref19) {
  var disabled = _ref19.disabled,
      bordered = _ref19.bordered;
  return !disabled && (bordered ? getTypeToken(TOKENS.backgroundButtonBorderedHover) : getTypeToken(TOKENS.backgroundButtonHover));
}, function (_ref20) {
  var disabled = _ref20.disabled,
      bordered = _ref20.bordered;
  return !disabled && (bordered ? getTypeToken(TOKENS.colorTextButtonBorderedHover) : getTypeToken(TOKENS.colorTextButtonHover));
}, getButtonBoxShadow(BUTTON_STATES.HOVER), IconContainer, function (_ref21) {
  var disabled = _ref21.disabled,
      bordered = _ref21.bordered;
  return !disabled && (bordered ? getTypeToken(TOKENS.colorTextButtonBorderedHover) : getTypeToken(TOKENS.colorTextButtonHover));
}, function (_ref22) {
  var disabled = _ref22.disabled,
      bordered = _ref22.bordered;
  return !disabled && css(["background:", ";color:", "!important;", ";& ", "{color:", ";}"], bordered ? getTypeToken(TOKENS.backgroundButtonBorderedActive) : getTypeToken(TOKENS.backgroundButtonActive), bordered ? getTypeToken(TOKENS.colorTextButtonBorderedActive) : getTypeToken(TOKENS.colorTextButtonActive), getButtonBoxShadow(BUTTON_STATES.ACTIVE), IconContainer, bordered ? getTypeToken(TOKENS.colorTextButtonBorderedActive) : getTypeToken(TOKENS.colorTextButtonActive));
}, getFocus, StyledSpinner, getSizeToken(TOKENS.loadingWidth), getSizeToken(TOKENS.loadingHeight));
StyledButton.defaultProps = {
  theme: defaultTheme
};
var StyledButtonContent = styled(function (_ref2) {
  var theme = _ref2.theme,
      loading = _ref2.loading,
      props = _objectWithoutProperties(_ref2, ["theme", "loading"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "Button__StyledButtonContent",
  componentId: "sc-1brqp3f-2"
})(["visibility:", ";height:100%;display:flex;flex-basis:100%;justify-content:center;align-items:center;", ";"], function (_ref23) {
  var loading = _ref23.loading;
  return loading && "hidden";
}, onlyIE(css(["min-width:100%;max-width:1px;"])));
StyledButtonContent.defaultProps = {
  theme: defaultTheme
};
var StyledButtonContentChildren = styled.div.withConfig({
  displayName: "Button__StyledButtonContentChildren",
  componentId: "sc-1brqp3f-3"
})(["display:inline-block;"]); // $FlowExpected

var Button = React.forwardRef(function (props, ref) {
  var _props$component = props.component,
      component = _props$component === void 0 ? "button" : _props$component,
      children = props.children,
      bordered = props.bordered,
      disabled = props.disabled,
      href = props.href,
      _props$size = props.size,
      size = _props$size === void 0 ? SIZE_OPTIONS.NORMAL : _props$size,
      icon = props.icon,
      iconRight = props.iconRight,
      external = props.external,
      _props$type = props.type,
      type = _props$type === void 0 ? TYPE_OPTIONS.PRIMARY : _props$type,
      fullWidth = props.fullWidth,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$width = props.width,
      width = _props$width === void 0 ? 0 : _props$width,
      role = props.role,
      onClick = props.onClick,
      circled = props.circled,
      submit = props.submit,
      tabIndex = props.tabIndex,
      ariaExpanded = props.ariaExpanded,
      className = props.className,
      ariaControls = props.ariaControls,
      spaceAfter = props.spaceAfter,
      dataTest = props.dataTest,
      title = props.title;
  var iconLeft = props.iconLeft || icon;
  var sizeIcon = size === ICON_SIZES.SMALL ? ICON_SIZES.SMALL : ICON_SIZES.MEDIUM;
  var onlyIcon = iconLeft && !children;
  var isDisabled = loading || disabled;
  warning(!(!children && !title), "Warning: children or title property is missing on Button. Use title property to add aria-label to be accessible for screen readers. More information https://orbit.kiwi/components/button/api/#accessibility");
  return React.createElement(StyledButton, {
    onClick: onClick,
    iconLeft: iconLeft,
    iconRight: iconRight,
    bordered: bordered,
    fullWidth: fullWidth,
    component: component,
    disabled: isDisabled,
    loading: loading,
    onlyIcon: onlyIcon,
    size: size,
    sizeIcon: sizeIcon,
    href: !disabled ? href : null,
    target: !disabled && href && external ? "_blank" : undefined,
    rel: !disabled && href && external ? "noopener noreferrer" : undefined,
    type: type,
    width: width,
    className: className,
    buttonRef: ref,
    role: role,
    circled: circled,
    submit: submit,
    tabIndex: tabIndex,
    ariaExpanded: ariaExpanded,
    ariaControls: ariaControls,
    dataTest: dataTest,
    spaceAfter: spaceAfter,
    title: title
  }, loading && React.createElement(Loading, {
    type: "buttonLoader"
  }), React.createElement(StyledButtonContent, {
    loading: loading
  }, iconLeft && React.createElement(IconContainer, {
    bordered: bordered,
    onlyIcon: onlyIcon,
    size: size,
    sizeIcon: sizeIcon,
    type: type
  }, iconLeft), children && React.createElement(StyledButtonContentChildren, null, children), iconRight && React.createElement(IconContainer, {
    bordered: bordered,
    onlyIcon: onlyIcon,
    size: size,
    sizeIcon: sizeIcon,
    type: type,
    right: true
  }, iconRight)));
});
Button.displayName = "Button";
export default Button;